import { render, staticRenderFns } from "./OlFeature.vue?vue&type=template&id=2d17bc41&scoped=true&"
import script from "./OlFeature.vue?vue&type=script&lang=ts&"
export * from "./OlFeature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d17bc41",
  null
  
)

export default component.exports